"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const shopLinks = [{
  label: "Pulmonary Care",
  to: "/pulmonary-care/"
}, {
  label: "Sleep Medicine",
  to: "/sleep-medicine/"
}, {
  label: "COPD Management",
  to: "/pulmonary-care/"
}, {
  label: "Asthma Care",
  to: "/pulmonary-care/"
}];
const serviceLinks = [{
  label: "Sleep Apnea Evaluation",
  to: "/sleep-medicine/"
}, {
  label: "CPAP Follow-Up",
  to: "/sleep-medicine/"
}, {
  label: "Oxygen Therapy",
  to: "/pulmonary-care/"
}, {
  label: "Chronic Cough",
  to: "/pulmonary-care/"
}];
const helpLinks = [{
  label: "Patient Information",
  to: "/patient-resources/"
}, {
  label: "For Referring Providers",
  to: "/referring-providers/"
}, {
  label: "Contact",
  to: "/contact/"
}];
const hours = [{
  day: "Mon–Thu",
  time: "9:00 AM — 5:00 PM"
}, {
  day: "Friday",
  time: "8:30 AM — 4:00 PM"
}, {
  day: "Sat–Sun",
  time: "Closed"
}];
export default function Footer() {
  return <section data-section-id="219" id="footer" className="bg-background text-foreground relative overflow-hidden border-t border-border">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-12 -right-16 opacity-10 hidden md:block">
        <svg width="420" height="420" viewBox="0 0 420 420" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M210 60 C 230 120, 260 150, 320 160 C 260 170, 230 200, 210 260 C 190 200, 160 170, 100 160 C 160 150, 190 120, 210 60 Z" stroke="var(--primary)" strokeWidth="1.2" fill="none" />
          <path d="M210 100 C 220 140, 240 160, 280 168 C 240 176, 220 196, 210 236 C 200 196, 180 176, 140 168 C 180 160, 200 140, 210 100 Z" stroke="var(--primary)" strokeWidth="1" fill="none" />
          <path d="M210 260 L 210 360" stroke="var(--chart-2)" strokeWidth="1.2" />
          <path d="M210 300 C 195 305, 185 320, 188 340" stroke="var(--chart-2)" strokeWidth="1" fill="none" />
          <path d="M210 320 C 225 325, 235 340, 232 360" stroke="var(--chart-2)" strokeWidth="1" fill="none" />
          <circle cx="210" cy="160" r="6" fill="var(--primary)" opacity="0.6" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14 pt-20 pb-10">
        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {}
          <div className="lg:col-span-1">
            <Link to="/HomePage" className="inline-block mb-6">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="font-serif text-lg font-medium text-foreground mb-2">
              Chaudhry Pulmonary Associates
            </p>
            <address className="not-italic font-default text-sm leading-relaxed text-slate-text">
              1321 5th Ave #202
              <br />
              McKeesport, PA 15132
            </address>
            <p className="mt-4 font-serif italic text-sm text-chart-2">
              Adult Pulmonary & Sleep Medicine
            </p>
            <div className="mt-6 space-y-1.5 font-default text-sm text-foreground">
              <p className="font-semibold">(412) 672-9240</p>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-mono text-[0.75rem] font-bold tracking-[0.15em] uppercase text-primary mb-5">
              Specialties
            </h3>
            <ul className="space-y-3">
              {shopLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="font-default text-sm text-foreground hover:underline underline-offset-4 decoration-chart-2 transition-all">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-mono text-[0.75rem] font-bold tracking-[0.15em] uppercase text-primary mb-5">
              Services
            </h3>
            <ul className="space-y-3">
              {serviceLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="font-default text-sm text-foreground hover:underline underline-offset-4 decoration-chart-2 transition-all">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-mono text-[0.75rem] font-bold tracking-[0.15em] uppercase text-primary mb-5">
              Hours
            </h3>
            <dl className="space-y-3">
              {hours.map((row, i) => <div data-index={i} key={row.day} className="flex items-baseline justify-between gap-4">
                  <dt className="font-serif italic text-sm text-foreground">
                    {row.day}
                  </dt>
                  <dd className="font-default text-sm text-slate-text tabular-nums">
                    {row.time}
                  </dd>
                </div>)}
            </dl>
            <div className="mt-8">
              <h3 className="font-mono text-[0.75rem] font-bold tracking-[0.15em] uppercase text-primary mb-5">
                Resources
              </h3>
              <ul className="space-y-3">
                {helpLinks.map((link, i) => <li data-index={i} key={link.label}>
                    <Link to={link.to} className="font-default text-sm text-foreground hover:underline underline-offset-4 decoration-chart-2 transition-all">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-border h-px" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="font-default text-xs text-slate-text tracking-wide">
            © {new Date().getFullYear()} Chaudhry Pulmonary Associates. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}